var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLensesIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Artboard Copy")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,3.02125721 L22.5,96.0212572",
    id: "Path-15",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5,3.02125721 L50.5,96.0212572",
    id: "Path-15-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,3.02125721 L78.5,96.0212572",
    id: "Path-15-Copy-2",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 23,
    cy: 34,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#FFFFFF",
    cx: 51,
    cy: 69,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#FFFFFF",
    cx: 79,
    cy: 27,
    r: 15
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLensesIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lenses_icon.6a6031f6.svg";
export { ForwardRef as ReactComponent };